import Vue from 'vue';
Vue.directive('currency', {
    bind: function (el, binding, vNode) {
        let val = binding.value;
        switch (val) {
            case 'RUB':
            case 'RUR': {
                val = '&#8381;';
                break;
            }
            case 'USD': {
                val = '$';
                break;
            }
            case 'EUR': {
                val = '&euro;';
                break;
            }
            case 'UAH': {
                val = '&#8372;';
                break;
            }
        }
        el.innerHTML = val;
    }
});